export const LOYALTY_FIELD = 'loyaltyNumber';
export const LOYALTY_NUMBER_MAX_LENGTH = 20;
export const LOYALTY_HELP_MESSAGE_ID = 'loyalty.loyaltyMessages.loyaltyHelpText';
